import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';


function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object; }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
    var ret = [];
    for (var i = 0; i < n; i++)
        ret.push(v instanceof Object ? clone(v) : v);
    return ret;
}

function bool(s) {
    if (typeof (s) == 'boolean') return s;
    if (!defined(s) || s === null) return false;
    if (typeof (s) == 'number') return s > 0;
    if (s.match(/^y/i)) return true;
    return false;
}

function sbool(v) {
    return ['No', 'Yes'][v];
}

var companyList = [];
function getCompanies(callback) {
    if (companyList.length) callback(companyList)
    window.post('find_companies', { match:{"active":true}}, function (res) {
        if (res.status) companyList = res.data.records;
        console.log('companyList', companyList);
        callback(companyList);
    })
}

var projects = {};
function getProjects( company, callback )
{
    if( projects[company] ) return callback( projects[company] );
    window.post('find_projects', { match: {active:true,company: company} }, function (res) {
        if (res.status) projects[company] = res.data.records;
        // console.log('projectList', projects[company]);
        callback(projects[company]);
    })
}

var datasets = {};
function getDatasets( company, callback )
{
    if( datasets[company] ) return callback( datasets[company] );
    window.post('find_datasets', { match: {active:true,company: company} }, function (res) {
        if (res.status) datasets[company] = res.data.records;
        // console.log('datasetList', datasets[company]);
        callback(datasets[company]);
    })
}

function UserSetup(prop) {

    var global = window.GlobalVars;
    var tab;
    var userEmail = null;
    let userRoles;

    async function checkRoleExists(user_data) {
        await frm.myAlertClose();
        console.log('hi1', user_data)
        console.log('hi2', userRoles)

        let roles = {
            'nlp_an': 'annotator',
            'nlp_qc': 'reviewer',
            'c_super': 'Project Supervisor',
            'c_super,api': 'Project Supervisor',
            'c_viewer': 'Project Viewer',
            'd_super': 'Dataset Supervisor',
            'd_super,api': 'Dataset Supervisor',
            'd_viewer': 'Dataset Viewer'
        }
        
        for (let role of userRoles) {
            if (user_data.priv === role.priv && user_data.company === role.company) {
                if (user_data.dataset && role.dataset && role.dataset[0].indexOf(user_data.dataset) > -1 && user_data.priv === role.priv) {
                    console.log('Already added', `User already added as ${roles[user_data.priv]} for ${role.datasetName[0]}`);
                    frm.myAlert('Already added', `User already added as ${roles[user_data.priv]} for ${role.datasetName[0]}`);
                    return true;
                }
                else if (user_data.project && role.project && role.project[0].indexOf(user_data.project) > -1 && user_data.priv === role.priv) {
                    console.log('Already added', `User already added as ${roles[user_data.priv]} for ${role.projectName[0]}`)
                    frm.myAlert('Already added', `User already added as ${roles[user_data.priv]} for ${role.projectName[0]}`);
                    return true;
                }
                else if(user_data.priv && !user_data.project && !user_data.dataset) {
                    console.log('Already added', `User already added as ${roles[user_data.priv]}`)
                    frm.myAlert('Already added', `User already added as ${roles[user_data.priv]}`);
                    return true;
                }
            }
        }
        return false;
    }
    
    
    function deleteRole(role) {
        function del() {
            role._del = true;
            window.post('update_user_role', { role: role }, function (res) {
                setTimeout(function () { document.location.reload(); }, 200);
            });
        }
        frm.myAlert('Delete Role', 'Do you really want to delete this role?<br>This operation can\'t be undone.', 'Yes', del, 'Cancel');
    }
    function editRole(role, add) {
        var origRole = clone(role);
        let clicked = false;
        async function cb(ev) {
            if (clicked) return;
            clicked = true;
            frm.removeInlineErrors()
            // alert( role.company )
            // if( !role.name || !role.name.trim() ) { alert( 'Role Name is required' ); return false; }
            if (!role.company || !role.company.trim()) {
                // alert('Company is required');
                setTimeout(function () { frm.inlineError($('.api'), 'Company is required') }, 500)
                clicked = false;
                return false;
            }
            if (!role.priv || !role.priv.trim()) {
                // alert('Choose at least one privilege for this role'); 
                setTimeout(function () { frm.inlineError($('.api'), 'Choose at least one role for this role') }, 500)
                clicked = false;
                return false;
            }
            if (role.priv.match(/(c_super|c_viewer)/)) {
                // if (!role.project) { $('#warnings').removeClass('hidden').addClass('block'); return false; }
                if (!role.project) {
                    setTimeout(function () { frm.inlineError($('.api'), 'Select at least one project') }, 500)
                    clicked = false;
                    return false;
                }
            }
            else
                delete role.project;
            if (role.priv.match(/(d_super|d_viewer)/)) {
                if (!role.dataset) {
                    // alert('Select at least one dastaset'); 
                    setTimeout(function () { frm.inlineError($('.api'), 'Select at least one dastaset') }, 500)
                    clicked = false;
                    return false;
                }
            }
            else
                delete role.dataset;

            if (role.priv.match(/api/) && !role.priv.match(/(admin|c_super|d_super)/)) {
                // alert('API Privilege must be combined with Admin or Supervisor');
                setTimeout(function () { frm.inlineError($('.api'), 'API Privilege must be combined with Admin or Supervisor') }, 500)
                clicked = false;
                return false;
            }
            var updateData = {
                _new: add || false,
                email: userEmail,
                name: role.name,
                company: role.company,
                priv: role.priv,
            };
            if (!add) updateData._id = role._id;
            updateData.project = role.project;
            updateData.dataset = role.dataset;
            console.log('UPDATE', updateData)
            // if (1) {alert(1); return;}
            if (await checkRoleExists(updateData)) return;
            window.post('update_user_role', { role: updateData }, function (res) {
                // console.log( 'UPDATE role', res )
                if (res.data.status) {
                    setTimeout(function () {
                        document.location.reload();
                    }, 200);
                }
                else {
                    frm.inlineError($('.api'), res.data.value)
                    clicked = false;
                    // alert(res.data.value);
                }
            });
            return false;
        }
        if (Date.now() > role.resetTimeout) role.resetPassword = null;
        var content = `
		<div id="roledetails">
		<label for="company">Company</label>
		<select placeholder="Company" type="text" id="company" class="mb-4 form-control"></select>
        <div class="projectselect hidden">
            <label for="project">Supervised Projects</label>
            <div id="projecthook" class="mb-2"></div>
            
        </div>
        <div class="datasetselect hidden">
            <label for="dataset">Supervised Datasets</label>
            <div id="datasethook" class="mb-2"></div>
            </div>        
            <div id="userPrivs"></div>
            </div>
            `;
        // <p class="hidden" id="warnings" style="color:red">Select at least one project</p>
        // <select placeholder="Dataset" type="text" id="dataset" class="mb-4 form-control"></select>
        //<select placeholder="Project" type="text" id="project" class="mb-4 form-control"></select>

        function checkSupervisor()
        {
            var psel = $('#roledetails').find('.projectselect').hide();
            var dsel = $('#roledetails').find('.datasetselect').hide();
            let pselOk = false;
            let dselOk = false;
            if( role.priv.match(/(c_super|c_viewer)/) ) {
                pselOk = true;
                psel.show();
            }
            if( role.priv.match(/(d_super|d_viewer)/) ) {
                dselOk = true;
                dsel.show();
            }

            console.log( 'role.priv', role.priv, 'psel', pselOk, 'dsel', dselOk )
            if( !role.priv.match(/(_super|_viewer)/) ) return;

            let delay = 1;
            if( pselOk ) {
                var opts = psel.find('option').length;
                if( !opts )
                {
                    getProjects( role.company, plist => {
                        var values = plist.map( p => {
                            return {
                                value: p.id,
                                label: p.name,
                            }
                        })
                        console.log( 'PLIST', values, role )
                        setTimeout( function(){
                            $('#projecthook').html('')
                            frm.itemList( $('#projecthook'), values, role.project, { width: '100%', placeholder: 'Select Project'}, function(v) {
                                role.project = v
                                console.log( 'role.project', role.project )
                            })
                        },delay)
                    } )
                }
            }
            if( dselOk ) {
                var opts = dsel.find('option').length;
                if( !opts )
                {
                    getDatasets( role.company, dlist => {
                        var values = dlist.map( d => {
                            return {
                                value: d.datasetId,
                                label: d.datasetName,
                            }
                        })
                        console.log( 'DLIST', values, role )
                        setTimeout( function(){
                            $('#datasethook').html('')
                            frm.itemList( $('#datasethook'), values, role.dataset, { width: '100%', placeholder: 'Select Dataset'}, function(v) {
                                role.dataset = v;
                            })
                        },delay)                        
                    } )
                }
            }
        }

        function changed() {
        }

        function close() {

        }
        var btnName = add ? 'Add role' : 'Update role';
        var title = add ? 'Add New Role' : 'Edit Role';
        getCompanies(function () {
            frm.myAlert(title, content, btnName, cb, 'Cancel', close);
            if (!add) {
                $('#roledetails').find('.email').remove();
                var focus = $('#roledetails').find('#name')
            }
            else {
                var focus = $('#roledetails').find('.email')

            }

            if (window.hasPriv('admin')) {
                $('#company').append('<option value="" disabled selected hidden>Select Company</option>');
                $('#company').on('change', updatePrivs);
            }
            else {
                role.company = companyList[0]._id;
            }
            companyList.forEach(c => $('#company').append('<OPTION value="' + c._id + '">' + c.name + '</OPTION>'));


            setTimeout(function () {
                if (companyList.length == 1) {
                    role.company = companyList[0]._id;
                    $('#company').val(role.company);
                } 
                focus.focus();
            }, 500);

            ['name', 'company', 'project','dataset'].forEach(n => {
                $('#roledetails').find('#' + n).val(role[n]).on('change', function () {
                    var id = $(this).prop('id');
                    var val = $(this).val();
                    console.log('change', id, val);
                    role[id] = val;
                    if( id == 'company' )
                    {
                        // delete role.project;
                        $('#project').html('');
                        // delete role.dataset;
                        $('#dataset').html('');
                        checkSupervisor();
                    }
                    changed();
                })
            })

            // frm.booleanList( $('#userActive'), role)
            frm.booleanList($('#userActive'), role, {
                items: {
                    'active': { default: false, label: 'Role Active' },
                },
                callbackOnInit: false,
            }, function (o) {
                role.active = o.active;
                changed()
            });

            function updatePrivs() {
                var userPrivs = role.priv ? frm.arr2Bool(role.priv.split(',')) : {};
                // delete userPrivs[''];
                var privItems = {};
                var cpriv = null;
                console.log('CLIST', companyList);
                if (!window.hasPriv('admin')) {
                    cpriv = companyList.find(c => c._id == window.GlobalVars.userCompany);
                    if (cpriv) cpriv = cpriv.priv.split(',');
                }

                console.log('CPRIV', cpriv)
                for (var p in window.privs) {
                    if (!cpriv || cpriv.indexOf(p) >= 0) privItems[p] = { default: false, label: window.privs[p] };
                }
                console.log( 'USERPRIVS', userPrivs, 'cpriv', cpriv, 'role', role.priv, role.priv.split(',') )
                window.userPrivs = userPrivs;
                frm.booleanList($('#userPrivs'), userPrivs, {
                    items: privItems,
                    header: ['', 'Privileges'],
                    callbackOnInit: false,
                }, function (o) {
                    var npriv = [];
                    console.log( 'role.priv cb', JSON.stringify(o), userPrivs )
                    for (var p in o) if (o[p]) npriv.push(p);
                    role.priv = npriv.join(',');
                    checkSupervisor();

                    console.log( 'role.priv privs', role.priv );
                    changed();
                });
                $('#userPrivs').find('input:checkbox').on('change', function(ev){
                    let opriv = role.priv;
                    var lab = $(this).prop('label');
                    if( lab == 'api') return ;
                    var checks = $('#userPrivs').find('input:checkbox');
                    var npriv = []
                    for( var i = 0 ; i < checks.length ; i++ ) {
                        var c = $(checks[i])
                        var cl = c.prop('label');
                        if( cl != 'api' && cl != lab && c.prop('checked')) {
                            console.log( 'role.priv disable check', cl, c  )
                            $(c).prop('checked', false)
                            userPrivs[cl] = false;
                        } else 
                        if( $(c).prop('checked') ) npriv.push(cl);
                    }
                    role.priv = npriv.join(',')
                    if( role.priv != opriv ) {
                        updatePrivs();
                    }
                    checkSupervisor();
                    // alert( role.priv )
                })
            }
            updatePrivs();
            checkSupervisor();
            frm.convertSelects($('select'));
        });
        return false;
    }





    useEffect(function (a) {
        $('#topbuttons').html('');




        $('#addrole').on('click', function () { editRole({ email: userEmail, priv: "" }, true) });

        var userSelect = window.GlobalVars.userProjectSelect == 1;
        if (userSelect) {
            var projBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 ml-2 btn btn-secondary">Assign users to project<span class="selcount"></span></Button>')
            $('#topbuttons').append(projBut);
            projBut.on('click', function () {
                if (Object.keys(window.GlobalVars.userTableCtx.selected) == 0) {
                    // return frm.myAlert( '', 'Please select users to be added to the project' );
                }
                else
                    window.GlobalVars.userProjectSelect = 2;
                window.saveSession();
                window.goPage('nlpWorkers');
            })
        }
        else {
            // window.GlobalVars.userTableCtx = {};
        }


        var match = { email: global.userSelected };
        window.post('find_users', { _keepqualification: true, match: match }, function (res) {
            console.log('users', res.data);
            var users = res.data.records;
            userRoles = res.data.records[0].roles;
            if (!users.length) {
                window.goPage('users');
                return;
                $('.alert').remove();
                var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No user found');
                $('#topbuttons').prepend(empty);
                $('#documentlist').hide();
                return;
            }
            var user = users[0];

            if (window.hasPriv('admin')) {
                var updateData = {email:user.email};
                var content = `
                <div id="userdetails" class="userdetails">
                    <div class="userdetailinline">
                    <label>User Email</label>
                    <div class="userdetailval">${user.email}</div>
                    </div>
                    <div class="userdetailinline">
                    <label for="username">User Name</label>
                    <input placeholder="User Name" type="text" id="username" class="mb-4 form-control" value="">
                    </div>
                    <div class="userdetailinline">
                    <div id="userActive"></div>
                    </div>
                    <div class="userdetailinline templ">
                    <label class="templabel">Temporary Password</label>
                    <input placeholder="Temporary Password (optional)" type="password" id="resetPassword" class="mb-4 form-control">
                    </div>
                    <div class="userdetailinline">
                    <button class="btn btn-primary" id="updateuser">Update user data</button>
                    </div>
                </div>
                `;
                $('#topbuttons').html(content);
                $('#username').on('change', function () { updateData.name = $(this).val().trim() }).val(user.name)
                $('#resetPassword').on('change', function () { updateData.resetPassword = $(this).val().trim() })

                let clicked = false;
                $('#updateuser').on('click', function(){
                    if( clicked ) return;
                    clicked = true;
                    window.post('update_user', { user: updateData }, async function (res) {
                        // console.log( 'UPDATE USER', res )
                        if (res.data.status) {
                            window.goPage('users');
                        }
                        else {
                            // alert(res.data.value);
                            clicked = false;
                            await frm.myAlertClose();
                            frm.myAlert(res.data.value);
                        }
                    });
                })
                frm.booleanList($('#userActive'), user, {
                    items: {
                        'active': { default: false, label: 'User Active' },
                    },
                    callbackOnInit: false,
                }, function (o) {
                    updateData.active = o.active;
                    // changed()
                });
            }
            else {
                var content = `
                <div id="userdetails" class="userdetails">
                    <div class="userdetailinline">
                    <label>User Email</label>
                    <div><b>${user.email}</b></div>
                    </div>
                    <div class="userdetailinline">
                    <label for="username">User Name</label>
                    <div><b>${user.name}</b></div>
                    </div>
                </div>
                `;
                $('#topbuttons').html(content);
            }



            userEmail = user.email;
            var desc = {
                selectMode: userSelect,
                selectId: 'email',
                title: 'User Roles',
                columns: {
                    // _id: 'Id',
                    // name: 'Name',
                    companyName: 'Company',
                    priv: 'Roles',
                    projectName: 'Project',
                    datasetName: 'Dataset',
                    lastLogin: 'Last Login',
                    delete: '',
                },
                filter: true,
                search: true,
                sort: true,
                // sortAlias: { lastLoginDelta: 'lastLogin' },
                // initialSort: 'lastLogin',
                // initialSortDir: -1,
                pageSize: 10,
                // noFilter: ['lastLogin'],
                noSearch: null,
                noSort: null,
                centerCol: true,
                format: tabler.formatString,
                formatCol: {
                    priv: tabler.formatPriv,
                    active: tabler.formatActive,
                    lastLogin: tabler.formatTimeAgo,
                    projectName: frm.smallerText,
                    datasetName: frm.smallerText,
                },
                forceType: { lastLogin: 1, active: 1, created: 1 },
                headerClick: 'filter',
                // clickCol: ['stateLabel','source'],
            }
            tab = tabler.table($('#documentlist'), desc);
            var forceOpen = null;
            user.roles.forEach(r => {
                // console.log( 'ADDROW', JSON.stringify(r,null,'\t') )
                r.delete = '<i class="fa fa-times-circle fa-lg worker-del"></i>';
                // r.projectName = r.project ? user.projects.find( p => p.id == r.project ).name : '';
                if( r.priv == '' ) forceOpen = r;
                // var pd = [];
                // if( r.projectName ) pd.push( r.projectName );
                // if( r.datasetName ) pd.push( r.datasetName );
                // r.pdName = pd.join(', ');
                tab.addRow(r, function (col, row) {
                    console.log('tabler click', r._id, col, row[col], row)
                    if( col == 'delete' ) return deleteRole(row);
                    editRole(row);
                    // fileClickTabler( col, row )
                })
            })
            tab.draw();
            tab.saveCtx(selCount);
            selCount();
            if( forceOpen ) setTimeout( function(){
                editRole( forceOpen );
            }, 100 )
            if( user.roles.length == 0 ) setTimeout( function(){
                editRole({ email: userEmail, priv: "" }, true)
            }, 100 )
            console.log('desc', desc, 'tabler', tabler.formatString)

            function expDate( ts ) {
                var ret = frm.localDateTime( ts );
                if( ts && Date.now() > ts*1000 ) ret +=  ' (expired)'
                return ret;
            }

            var badgeDesc = {
                selectMode: userSelect,
                selectId: 'badge',
                title: 'User Badges',
                columns: {
                    // _id: 'Id',
                    // name: 'Name',
                    projectType: 'Type',
                    badge: 'BadgeName',
                    label: 'Label',
                    created: 'Granted&nbsp;' + frm.smallerText(frm.timeZone()),
                    expire: 'Expiration&nbsp;'+ frm.smallerText(frm.timeZone()),
                },
                filter: true,
                search: true,
                sort: true,
                // sortAlias: { lastLoginDelta: 'lastLogin' },
                // initialSort: 'lastLogin',
                // initialSortDir: -1,
                pageSize: 10,
                // noFilter: ['lastLogin'],
                noSearch: null,
                noSort: null,
                centerCol: true,
                format: tabler.formatString,
                formatCol: {
                    priv: tabler.formatPriv,
                    active: tabler.formatActive,
                    created: frm.localDateTime,
                    expire: expDate,
                },
                clickCol: 'none',
                forceType: { lastLogin: 1, active: 1, created: 1, expire: 1 },
                headerClick: 'filter',
                // clickCol: ['stateLabel','source'],
            }
            var btab = tabler.table($('#badgelist'), badgeDesc);
            console.log( 'USER', user )
            user.qualification.forEach(r => {
                // console.log( 'ADD', r )
                // r.created *= 1000;
                // r.expire *= 1000;
                btab.addRow(r, function (col, row) {
                })
            })
            btab.draw();
        });
    });

    function selCount() {
        var ctx = tabler.getCtx('users');
        var s = ctx.selected || {};
        $('.selcount').text(' (' + Object.keys(s).length + ')')
    }

    return (
        <div fluid="md p-0" className="maincontent">
            <div id="topbuttons"></div>
            <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
            </Table>
            <button id="addrole" className="btn btn-primary"><i class="fa fa-plus mr-2"></i>Add new role</button>
            <Table id="badgelist" bordered hover size="sm" className="table-grid mt-3">
            </Table>
            <span>&nbsp;</span>
        </div>
    )
}

export default UserSetup
